module.exports = __webpack_public_path__ + "static/media/tbn_2.bb402279.webp";